import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { accountsNames } from '../constants'
import { checkRequiredFields, searchAccountAndInitialize } from '../helpers'
import { loadClientDetails } from '../../../store/client'
import { accountViewBase } from 'src/store/account'
import { ChooseAccountOwnerButtonProps } from './ClientAccountChoosePanel.types'
import { AppDispatch } from 'src/store/index.d'

//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  dispatch,
}))
class ChooseAccountOwnerButton extends React.Component<ChooseAccountOwnerButtonProps> {
  state: {
    fetching: boolean
    clientId: number
  } = { fetching: false, clientId: null }

  handleChooseAccountOwner = async () => {
    const {
      initialClient,
      initialIDDoc,
      initialDelegate,
      AccID,
      AccHash,
      AccNo,
      ChosenAccNo,
      form,
      client,
      embedded,
      CardNumberSearch,
      onChooseClientRequest,
      change,
    } = this.props

    if (embedded) {
      change('ClientType', initialClient.ClientTypeID.toString())
      change('Client', initialClient)
      change('IDDoc', initialIDDoc)
      change('Delegate', initialDelegate)
      change('CardNumberSearch', '')
      change('clientID', initialClient.ID)
      change('clientHash', initialClient.HashSum_ClientID_)
      change('clientIsChosen', true)
      if (this.props.onChoose) this.props.onChoose(initialClient)
      return
    }

    if (client && this.state.clientId === client.ID) {
      const clientDetailsResult = await this.props.loadClientDetails({
        clientId: client.ID,
        clientHash: client.HashSum_ClientID_,
      })

      if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
        const clientDetails = clientDetailsResult.payload

        if (clientDetails.Black === 1) {
          throw new Error('CLIENT_IN_BLACK_LIST')
        }

        await checkRequiredFields(
          this.props.change,
          this.props.form,
          clientDetails,
          this.props.openClientEditConfirmation,
          this.props.dispatch,
        )

        if (this.props.onChoose) {
          this.props.onChoose(clientDetails)
        }
      }

      return
    }

    if (AccNo) {
      this.setState({ fetching: true })

      let startingPointData = null

      if (ChosenAccNo.toString().trim() !== AccNo.toString().trim()) {
        startingPointData = await searchAccountAndInitialize({
          dispatch: this.props.dispatch,
          fetcherName: 'searchAccountAndInitializeFetcherName',
          accountNo: AccNo,
          FormName: form,
          accountCredentials: this.props.cashOut ? accountsNames.debit : accountsNames.credit,
          ccyName: this.props.ccyName,
        })
      } else {
        startingPointData = { ID: AccID, hash: AccHash }
      }

      // 1. Request account details
      // 2. Check if account is found (if not throw error)
      // 3. Request client details
      // 4. Check if client is in black list (if so throw error)
      // 5. Request client required fields check
      // 6. Check if client is valid

      try {
        const accountDetailsResult = await this.props.accountViewBase({
          AccountID: startingPointData.ID,
          HashSum_AccountID_: startingPointData.hash,
        })

        if (accountViewBase.fulfilled.match(accountDetailsResult)) {
          const accountDetails = accountDetailsResult.payload
          if (accountDetails.ClientID) {
            this.setState({
              clientId: accountDetails.ClientID,
            })

            const clientDetailsResult = await this.props.loadClientDetails({
              clientId: accountDetails.ClientID,
              clientHash: accountDetails.HashSum_ClientID_,
            })

            if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
              const clientDetails = clientDetailsResult.payload

              if (clientDetails.Black === 1) {
                throw new Error('CLIENT_IN_BLACK_LIST')
              }

              await checkRequiredFields(
                this.props.change,
                this.props.form,
                clientDetails,
                this.props.openClientEditConfirmation,
                this.props.dispatch,
              )

              if (this.props.onChoose) {
                this.props.onChoose(clientDetails)
              }
            }
          } else if (CardNumberSearch && CardNumberSearch.trim() !== '') {
            onChooseClientRequest(CardNumberSearch)
          } else {
            throw new Error('No client found on this account')
          }
        }
      } catch (error) {
        if (error.message === 'CLIENT_IN_BLACK_LIST') {
          this.props.openClientBlackedModal()
        }
      } finally {
        this.setState({ fetching: false })
      }
    } else if (CardNumberSearch && CardNumberSearch.trim() !== '') {
      onChooseClientRequest(CardNumberSearch)
    }
  }

  render() {
    const { fetching } = this.state
    const { disabled, embedded, AccID } = this.props
    return (
      <LKButton
        disabled={fetching || disabled || !AccID}
        loading={fetching}
        onClick={this.handleChooseAccountOwner}
        alias="client"
      >
        {translate(embedded ? 'frm_acc_entry_add-cmd_borrower' : 'frm_acc_entry_add-cmd_acc_owner')}
      </LKButton>
    )
  }
}

export default connect(
  (state, { form, cashOut }: { form: string; cashOut: boolean }) => ({
    AccID: formValueSelector(form)(state, cashOut ? 'DebitAccID' : 'CreditAccID'),
    AccNo: formValueSelector(form)(state, cashOut ? 'DebitAccNo' : 'CreditAccNo'),
    ChosenAccNo: formValueSelector(form)(state, cashOut ? 'DebitChosenAccNo' : 'CreditChosenAccNo'),
    AccHash: formValueSelector(form)(state, cashOut ? 'DebitAccHash' : 'CreditAccHash'),
    ccyName: formValueSelector(form)(state, 'CCY'),
    CardNumberSearch: formValueSelector(form)(state, 'CardNumberSearch'),
  }),
  {
    loadClientDetails,
    accountViewBase,
  },
)(ChooseAccountOwnerButton)
